import {
  KEYWORD_REQUEST_RESPONSE,
  KEYWORD_REQUEST_FAILURE,
  KEYWORD_REQUEST_REQUEST
} from "../../actions/types";

const initialSortPosition = [
  { value: "keyword", label: "Area Of Focus", order: "asc" },
  { value: "related_doc_count", label: "Related Docs", order: "desc" },
  { value: "realted_position", label: "Related Docs Position", order: "desc" },
  { value: "citation", label: "Citation", order: "desc" },
  { value: "citation_position", label: "Citation Position", order: "desc" },
];

const initialState = {
  isFetching: true,
  keywords: [],
  error: false,
  activeSortItems: initialSortPosition,
  activePage: 1,
  size: 10,
  from: 0,
  total: 0
};

const setRequest = (state, action) => {
  return {
    ...state,
    isFetching: true,
    error: false,
    keywords: [],
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true
  };
};

const setResponse = (state, action) => {
  let { keywords = [], activeSortItems, activePage, total } = action.payload;
  return {
    ...state,
    isFetching: false,
    error: false,
    keywords: keywords,
    activePage,
    activeSortItems,
    total
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case KEYWORD_REQUEST_RESPONSE:
      return setResponse(state, action);
      break;

    case KEYWORD_REQUEST_FAILURE:
      return setFailure(state, action);
      break;

    case KEYWORD_REQUEST_REQUEST:
      return setRequest(state, action);

    default:
      return state;
      break;
  }
};
